module.exports = __webpack_public_path__ + "static/media/Background.e7e299cb.svg";